export const DEFAULT_SUCCESS_SMS_MESSAGE = 'SMS sent successfully!';
export const DEFAULT_ERROR_SMS_MESSAGE = 'Failed to send SMS!';
export const DEFAULT_SUCCESS_EMAIL_MESSAGE = 'Email sent successfully!';
export const DEFAULT_ERROR_EMAIL_MESSAGE = 'Failed to send email!';
export const SMS_MUTATION_KEY = 'send_sms';
export const EMAIL_MUTATION_KEY = 'send_email';

export type SmsConfig = {
  from: string;
  templateSid: string;
  callbackUrl?: string;
};

export const getSmsModel = (
  selectedParticipant: any,
  smsConfig?: SmsConfig,
) => {
  if (!smsConfig || !smsConfig.from) {
    console.error('SMS config is missing');
    return;
  }
  return {
    from: smsConfig.from,
    recipients: [selectedParticipant?.championshipMobile],
    templateSid: smsConfig.templateSid,
    parameters: { FirstName: selectedParticipant?.firstName },
  };
};

export type EmailConfig = {
  from: string;
  replyTo?: string;
  subject?: string;
  templateName?: string;
  callbackUrl?: string;
};
export const getEmailModel = (
  selectedParticipant: any,
  emailConfig?: EmailConfig,
) => {
  if (!emailConfig || !emailConfig.from || !emailConfig.templateName) {
    console.error('Email config is missing');
    return;
  }

  return {
    fromEmail: emailConfig.from,
    recipients: [selectedParticipant.championshipEmail],
    replyTo: emailConfig.replyTo || '',
    subject: emailConfig.subject || '',
    templateName: emailConfig.templateName,
    attachments: [],
    parameters: {
      FirstName: selectedParticipant?.firstName,
    },
    body: null,
  };
};
